import React from 'react';

import MCard from 'app/ui/MCard/MCard';
import MIcon from 'app/ui/MIcon/MIcon';

import classes from './ReviewBox.module.scss';

interface Props {}

const ReviewBoxView: React.FC<Props> = () => {
  return (
    <MCard className={classes['container']}>
      <div className={classes['header']}>
        <div className={classes['stars']}>
          <MIcon className={classes['stars__item']} name="cisStar"></MIcon>
          <MIcon className={classes['stars__item']} name="cisStar"></MIcon>
          <MIcon className={classes['stars__item']} name="cisStar"></MIcon>
          <MIcon className={classes['stars__item']} name="cisStar"></MIcon>
          <MIcon className={classes['stars__item']} name="cisStar"></MIcon>
        </div>
        <span>July 27, 2021</span>
      </div>
      <p className={classes['description']}>Easy booking and efficient travel between Mljet and Korcula.</p>
      <span className={classes['author']}>- Anton Plankton</span>
    </MCard>
  );
};

ReviewBoxView.displayName = 'ReviewBoxView';
ReviewBoxView.defaultProps = {};

export default ReviewBoxView;
